import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

export interface HelpTextSegment {
  text: string;
  url?: string;
}

@Component({
  selector: 'app-help-text-links',
  templateUrl: './help-text-links.component.html',
  styleUrl: './help-text-links.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HelpTextLinksComponent implements OnChanges {
  @Input() text: string = '';

  public segments: HelpTextSegment[] = [];

  ngOnChanges(): void {
    this.segments = this.buildSegments(this.text || '');
  }

  private buildSegments(text: string): HelpTextSegment[] {
    const segments: HelpTextSegment[] = [];
    const urlPattern = /(https?:\/\/[^\s<>"']+|www\.[^\s<>"']+)/gi;
    let textStart = 0;
    let match: RegExpExecArray | null;

    while ((match = urlPattern.exec(text)) !== null) {
      if (match.index > textStart) {
        segments.push({ text: text.substring(textStart, match.index) });
      }

      const matchedValue = match[0];
      const url = matchedValue.replace(/[.,;:!?\])}]+$/, '');
      const trailingText = matchedValue.substring(url.length);
      segments.push({
        text: '(click here)',
        url: url.toLowerCase().startsWith('www.') ? `https://${url}` : url
      });
      if (trailingText) {
        segments.push({ text: trailingText });
      }

      textStart = match.index + matchedValue.length;
    }

    if (textStart < text.length) {
      segments.push({ text: text.substring(textStart) });
    }

    return segments;
  }
}
